/**
 * Archived boards (FOR-349): copy, the archived list's query key and dates.
 * The components live in components/tasks/board-archive.tsx, the mutation in
 * hooks/use-board-archive.ts.
 */

import { format, parseISO } from "date-fns"

export const ARCHIVE_BOARD_EXPLAINER =
  "Archived boards are hidden from the sidebar and pickers. Their tasks stay readable but can't be changed. Webhooks and app tokens pause until you unarchive."

/** The query key of the "Archived boards" list. Under ["boards"], so invalidating that refreshes it too. */
export const ARCHIVED_BOARDS_QUERY_KEY = ["boards", "archived"] as const

export function formatArchivedDate(iso: string | null | undefined): string | null {
  if (!iso) return null
  const date = parseISO(iso)
  return Number.isNaN(date.getTime()) ? null : format(date, "MMM d, yyyy")
}
